import { render } from "./DistributionPlotsSection.vue?vue&type=template&id=15715c15&scoped=true"
import script from "./DistributionPlotsSection.vue?vue&type=script&lang=js"
export * from "./DistributionPlotsSection.vue?vue&type=script&lang=js"

import "./DistributionPlotsSection.vue?vue&type=style&index=0&id=15715c15&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15715c15"]])

export default __exports__